import React,{useState} from 'react';
// styling
import '../App.css';
import { Button, Modal, Form, Input } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import chainSound from './../assets/chain.mp3'


const NewContact = props => {
  const [name, setName] = useState('');
  const [number, setPhoneNumber] = useState('');

  const { setPopUp, popUp } = props
    const { contactList } = props
    const { messagesList } = props

  const handleCreateContact = () => {
    // Vérifier si les champs sont valides
    if (name.trim() === '' || number.trim() === '') {
      alert('Veuillez remplir tous les champs.');
      return;
    }

    // Appeler la fonction onCreateContact avec les données du nouveau contact
    onCreateContact({ name, number });

    // Réinitialiser les champs
    setName('');
    setPhoneNumber('');

    // Fermer la fenêtre modale
    onClose();
  };
  const onClose = () => {
    setPopUp(false)
  }

  const open = () => {
    setPopUp(true)
  }
  function contactInfIsCorrect(newContact){
        return messagesList.find(contact => contact.num === newContact.number) !== undefined && contactList.find((contact) => contact.number === newContact.number) === undefined
  }
  const onCreateContact = (newContact) => {
    // Vérifier si le numéro de téléphone est déjà utilisé et est présent dans les numéro déjà possible
    console.log(contactInfIsCorrect(newContact))
    if (!contactInfIsCorrect(newContact)) {
      alert("Ce numéro de téléphone est déjà utilisé ou n'est pas attribué");
      return;
    }

    // set nickname
    messagesList.find(contact => contact.num === newContact.number).nickname = newContact.name

    // Ajouter le nouveau contact à la liste des contacts

    contactList.push(newContact)
    const chain = new Audio(chainSound);
    chain.play();
  }

  return (
    popUp &&
    <Modal open={open} onClose={onClose} size="tiny">
      <Modal.Header>Créer un nouveau contact</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>Nom</label>
            <Input
              placeholder="Entrez le nom du contact"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Field>
          <Form.Field>
            <label>Numéro de téléphone</label>
            <Input
              placeholder="N° de téléphone +33900000000"
              value={number}
              onChange={(e) => setPhoneNumber(e.target.value.replace(/ /g,''))}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={onClose}>
          Annuler
        </Button>
        <Button positive onClick={handleCreateContact}>
          Créer
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default NewContact;
